import { render } from "./DragVotingToPointModal.vue?vue&type=template&id=5fb03a94&scoped=true"
import script from "./DragVotingToPointModal.vue?vue&type=script&lang=js"
export * from "./DragVotingToPointModal.vue?vue&type=script&lang=js"

import "./DragVotingToPointModal.vue?vue&type=style&index=0&id=5fb03a94&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb03a94"]])

export default __exports__